module.exports = __webpack_public_path__ + "img/icon-56.304d70c0.svg";